import { FilterSection } from "@flights/search-ui";
import React from "react";
import { Stack, Tab } from "@bookingcom/bui-react";
import { useFlightTimesFilterController } from "./useFlightTimesFilter.controller";
import { OptionsList } from "./OptionsList";
import flights_web_budget_layover_airports_filters from "../../../../../utils/experiments/funnel/flights_web_budget_layover_airports_filters";

export const FlightTimesFilterMobile = () => {
  const { isFilterAvailable, title, showReset, resetLabel, onClickReset, moreLabel, options, currentBound } =
    useFlightTimesFilterController();

  if (!isFilterAvailable) return null;

  const addNewFilters = !!flights_web_budget_layover_airports_filters.trackWithDefaultStage();

  return (
    <FilterSection
      attributes={{ "data-testid": "flight_times_filter" }}
      title={{
        text: title,
        tagName: "h3",
        attributes: { id: "flight_times_filter" },
        variant: addNewFilters ? "strong_2" : "emphasized_1"
      }}
      reset={
        showReset && !addNewFilters
          ? {
              text: resetLabel,
              onClick: onClickReset,
              attributes: { "data-testid": "search_filter_flight_times_reset" }
            }
          : undefined
      }
    >
      {!!currentBound ? (
        <OptionsList optionIndex={currentBound === "outbound" ? 0 : 1} />
      ) : options.length === 1 ? (
        <OptionsList optionIndex={0} />
      ) : (
        <Tab vertical={false} moreLabel={moreLabel} fillEqually={true}>
          <Stack>
            <Tab.TriggerList>
              {options.map(({ labels }, i) => {
                return (
                  <Tab.Trigger
                    id={labels.title}
                    text={labels.title}
                    key={labels.title + i}
                    linkAttributes={{ "data-testid": `flight_times_filter_v2_flight_times_button_${i}` }}
                  />
                );
              })}
            </Tab.TriggerList>
            {options.map(({ labels }, optionIndex) => {
              return (
                <Tab.Panel key={labels.title + optionIndex} id={labels.title}>
                  <OptionsList optionIndex={optionIndex} />
                </Tab.Panel>
              );
            })}
          </Stack>
        </Tab>
      )}
    </FilterSection>
  );
};
